import React from "react";
import { CRMCardOutsideLabelled } from "../../components/CRMCardOutsideLabelled/CRMCardOutsideLabelled";
import { CRMTitleForCard } from "../../components/CRMTitleForCard/CRMTitleForCard";
import { CRMSellerKeyInfoComponent } from "../../components/CRMSellerKeyInfoComponent/CRMSellerKeyInfoComponent";
import { CRMSellerPersonComponent } from "../../components/CRMSellerPersonComponent/CRMSellerPersonComponent";
import { CRMPartyGroupHeading } from "../../components/CRMPartyGroupHeading/CRMPartyGroupHeading";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { SpacingColumn } from "../../components/BuildingBlocks/SpacingColumn";
import { CRMSpacing } from "../../models/CRMSpacing";
import { groupMembersByPartyRole } from "../../models/CRMPartyRoleGrouping";
import * as PartyUserRole1 from "../../../../domain/models/PartyUserRole1";
import * as User4 from "../../../../domain/models/User4";
import { TUserCaseUserType } from "../../../../domain/codecs/UserCaseUserType";

const roleForUser = (roles: Array<PartyUserRole1.T> | undefined, user: User4.T): TUserCaseUserType =>
    (roles ?? []).find((role) => role.user_id === user.id)?.user_type ?? "unknown";

class CRMListingPerformancePageSellerSummaryContainer extends React.Component<React.PropsWithChildren<TContainerStateProps>> {

    public render(): JSX.Element {
        const party = this.props.state.activeData.crm.listingPerformance.partyForm.view;

        return (
            <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                {/* SELLER SUMMARY */}
                <CRMCardOutsideLabelled
                    labelColor="highlights-calming-pink-4"
                    shadow={false}
                >
                     <SpacingColumn spacing={CRMSpacing.TINY}>
                        <CRMTitleForCard>
                            The Seller
                        </CRMTitleForCard>
                        <CRMSellerKeyInfoComponent
                            listing={this.props.state.activeData.crm.listingPerformance.listingForm.view}
                            visibleSections={[
                                "looking-for",
                                "view-on-offers",
                            ]}
                        />
                     </SpacingColumn>
                </CRMCardOutsideLabelled>

                {/* SELLER CONTACT CARDS, UNDER A HEADING PER ROLE */}
                {groupMembersByPartyRole({
                    members: party.users,
                    getUserType: (user) => roleForUser(party.user_roles, user),
                    getSortName: (user) => `${user.last_name} ${user.first_name}`,
                }).map((group) => (
                    <SpacingColumn key={group.label} spacing={CRMSpacing.SMALL}>
                        <CRMPartyGroupHeading
                            label={group.label}
                            tone={group.tone}
                            count={group.members.length}
                        />

                        <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                            {group.members.map((user, index) => (
                                <CRMCardOutsideLabelled
                                    key={index}
                                    labelColor={group.tone === "passive" ? "neutral-6" : "highlights-positive-green-6"}
                                    shadow={false}
                                >
                                    <CRMSellerPersonComponent user={user} />
                                </CRMCardOutsideLabelled>
                            ))}
                        </SpacingColumn>
                    </SpacingColumn>
                ))}
            </SpacingColumn>
        );
    }
}

export default CRMListingPerformancePageSellerSummaryContainer;
